import React from 'react';
import { Link } from 'react-router-dom';

const ItemTicket = (props) => {
    return (
        <Link to={`/tickets/inner-page/${props.data.id}`} className="item-ticket">
            <span><strong>{props.data.id}</strong>شماره تیکت : </span>
            <h4>{props.data.title}</h4>
            <div className="details">
                <span>{props.data.jdate}</span>
                <strong 
                  className={`${props.data.status === 'close' ? 'closed' : 'opened'}`}>
                    {props.data.status_message}
                </strong>
            </div>
            {props.data.status !== 'close' && props.data.status !== 'open' ?
                <b></b>
                : null
            }
        </Link>
    );
}

export default ItemTicket;